/**
 * Handles Notification Link Click Event
 * @param action
 */
import { ENV_DEVELOPMENT } from '@vfde-sails/constants';
import { NOTIFICATION_HOTLINE_LINK_ID } from 'Constant';
import { OFFER_CARD_PRICE_DETAILS } from 'Container/OfferDisplay/constant';

/**
 * Initializes the Click on open the accordion
 * @param action
 */
export const handleAccordionChangeEvent = (item, action) => {
    try {
        // get DOM Element by Id
        const accordionItem = <HTMLInputElement>document.getElementById(`accordion-input-${item}`);
        // checked means: the accordion has opened
        const {checked} = accordionItem;
        if (true === checked) {
            // Offer-Id is the last part of the DOM Element-Id
            const idArray = accordionItem.id.split('-');
            const offerId = idArray[idArray.length - 1];
            action(offerId);
        }
    } catch (e) { }
};

/**
 * Action, that is done, when Offer-Price Button is clicked
 * @param action
 */
export const handleButtonClickEvent = (event, action) => {
    try {
        // Target can be the button itself or the span inside. It depends
        // on where the user clicks
        const targetButton = event.target;
        let href = targetButton.getAttribute('href');
        if (null === href) {
            const targetSpan = targetButton.parentElement;
            href = targetSpan.getAttribute('href');
        }
        // if the href includes "tel:" it's a Hotline-CTA
        // in this case, tracking is triggered
        if (0 <= href.toLowerCase().indexOf('tel:')) {
            const tel = href.split(':')[1];
            action(tel);
        }

    } catch (e) { }
};

/**
 * Handles Scroll event
 * @param action
 */
export const handleScrollEvent = action => {
    let ticking = false;
    window.addEventListener('scroll', (e) => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                trackApplyFilterIfInViewport(action);
                ticking = false;
            });
            ticking = true;
        }
    });
};

/**
 * Returns true, if top of element goven by parameter enters viewport
 * @param el
 */
const isElementInViewport = el => {
    const rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
};

/**
 * Checks, if offer is in viewport and fires tracking status
 * @param action
 */
export const trackApplyFilterIfInViewport = action => {
    try {
        const accordions = document.getElementsByClassName(OFFER_CARD_PRICE_DETAILS);
        const accordionsLength = accordions.length;

        for (let i = 0; i < accordionsLength; i++) {
            if (true === isElementInViewport(accordions[i])) {
                action();
            }
        }
    } catch (e) { }
};

/**
  * Initializes the Click on open the accordion
  * @param action
  */
export const handleNotificationLinkClickEvent = (action) => {
    try {
        // Target can be the button itself or the span inside. It depends
        // on where the user clicks
        const notificationLink = document.getElementById(NOTIFICATION_HOTLINE_LINK_ID);
        const href = notificationLink.getAttribute('href');

        // if the href includes "tel:", the tracking is triggered
        if (0 <= href.toLowerCase().indexOf('tel:')) {
            const tel = href.split(':')[1];
            notificationLink.addEventListener('click', (e) => {
                action(tel);
            });
        }
    } catch (e) {}
};

/**
 * Handle Legacy click event bindings
 *
 * @TODO Remove as soon as issue is fixed in core.js by using event delegation or components are in brix
 */
export const handleLegacyClickEventBindings = () => {

    if (process.env.NODE_ENV !== ENV_DEVELOPMENT) {
        try {

            // Initialize simplicity footnotes
            (window as any).vf.footnotes.init();

        } catch (err) {
            // can't do anything about that
        }
    }
};
